import React from 'react';
import { ServicesHero } from './ServicesHero';
import { ServicesGrid } from './ServicesGrid';
import { ServicesCTA } from './ServicesCTA';
export function Services() {
  return <div className="min-h-screen w-full bg-white" data-id="element-569">
      <ServicesHero data-id="element-570" />
      <ServicesGrid data-id="element-571" />
      <ServicesCTA data-id="element-572" />
    </div>;
}